module.exports = __webpack_public_path__ + "static/media/icon-entrega.ffd20984.svg";